export { default } from './MaskedTextInput';
export type { MaskedTextInputProps } from './MaskedTextInput';
